// @flow

import React, { Component } from "react";
import { Record } from "immutable";

import AdInjectComponent from "./Component";

import LiveSourceAPI from "../LiveSource/API";

const InjectionRecord = Record({ loading: false });

type State = {
  injection: InjectionRecord
};

type Props = {
  useImage: boolean,
  sendAdInjectionSignal: (duration: number) => Promise<any>,
  getElementalImage: () => Promise<Response>,
  adBreakRequested: () => void
};

class AdInject extends Component<Props, State> {
  state = {
    injection: new InjectionRecord()
  };

  componentDidMount() {
    if (this.props.useImage) {
      const img = ((document.getElementById(
        "imageCanvas"
      ): any): HTMLImageElement);

      const updateImage = () => {
        return this.props
          .getElementalImage()
          .then(resp => resp.arrayBuffer())
          .then(buf => {
            const base64String = btoa(
              String.fromCharCode(...new Uint8Array(buf))
            );

            const imageData = "data:image/jpeg;base64," + base64String;
            if (img) {
              img.src = imageData;
            }
          })
          .then(() => setTimeout(updateImage, 500));
      };

      updateImage();
      return;
    }
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    return !this.state.injection.equals(nextState.injection);
  }

  videoElementMounted(el: HTMLVideoElement) {
    if (el == null) {
      return;
    }
    console.count("video element mounted");
    const api = new LiveSourceAPI(el);
    api.start();
    console.log(el);
  }

  clickedAdInject(duration: number) {
    this.props.adBreakRequested();

    this.setState(state => ({
      injection: state.injection.set("loading", true)
    }));
    this.props.sendAdInjectionSignal(duration).then(() => {
      this.setState(state => ({
        injection: state.injection.set("loading", false)
      }));
    });
  }

  render() {
    return (
      <AdInjectComponent
        useImage={this.props.useImage}
        videoElementMounted={this.videoElementMounted.bind(this)}
        clickedHandler={this.clickedAdInject.bind(this)}
        loading={this.state.injection.get("loading")}
      />
    );
  }
}

export default AdInject;



// WEBPACK FOOTER //
// ./src/AdInject/index.js